import {
  Button,
  ButtonGroup,
  Icon,
  view,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  PropertyList,
  PropertyListItem,
} from '@sail/ui';
import {InlineDatumReactComponentProps} from '@stripe-internal/inline-data';
import {arrowDown, arrowUp} from '@sail/icons/react/Icon';

export type Period = 'Morning' | 'Afternoon' | 'Evening' | 'Night';

export type ValueProps = {
  period: Period;
  desired_temp: number;
  merchant_name?: string | null;
};

export const ProgrammableThermostatSample = (
  props: InlineDatumReactComponentProps,
) => {
  const {datum, action, fetch} = props;
  const value = datum.value as ValueProps;
  const {
    period,
    desired_temp: desiredTemp,
    merchant_name: merchantName,
  } = value;

  const selectPeriod = (selectedPeriod: Period) => {
    fetch({
      period: selectedPeriod,
    });
  };

  const incTemp = () => {
    action({
      period,
      delta: 1,
    });
  };

  const decTemp = () => {
    action({
      period,
      delta: -1,
    });
  };

  return (
    <view.div
      data-testid="mse-inline-data:programmable-thermostat-sample"
      css={{
        backgroundColor: 'surface',
        borderRadius: 'xsmall',
        padding: 'medium',
        boxShadow: 'top',
        ':hover': {
          boxShadow: 'hover',
        },
      }}
    >
      <h3>Programmable Thermostat</h3>
      {merchantName ? (
        <PropertyList>
          <PropertyListItem
            label="Merchant Name"
            value={merchantName}
            data-testid="merchant-name"
          />
        </PropertyList>
      ) : null}
      <Tabs
        fitted
        selectedKey={period}
        onSelectionChange={(key) => selectPeriod(key as Period)}
        css={{stack: 'y', gap: 'medium'}}
      >
        <TabList>
          <Tab key="Morning" id="Morning">
            Morning
          </Tab>
          <Tab key="Afternoon" id="Afternoon">
            Afternoon
          </Tab>
          <Tab key="Evening" id="Evening">
            Evening
          </Tab>
          <Tab key="Night" id="Night">
            Night
          </Tab>
        </TabList>
        <TabPanels>
          {['Morning', 'Afternoon', 'Evening', 'Night'].map((p) => (
            <TabPanel key={p} id={p}>
              <view.div css={{stack: 'y', gap: 'medium'}}>
                <PropertyList>
                  <PropertyListItem
                    label={`${p} Desired Temperature`}
                    value={desiredTemp}
                    data-testid={`${p}-desired-temp`}
                  />
                </PropertyList>
                <ButtonGroup>
                  <Button
                    onPress={decTemp}
                    data-testid={`dec-${p}-temp-btn`}
                    size="medium"
                    type="secondary"
                  >
                    <Icon icon={arrowDown} />
                  </Button>
                  <Button
                    onPress={incTemp}
                    data-testid={`inc-${p}-temp-btn`}
                    size="medium"
                    type="secondary"
                  >
                    <Icon icon={arrowUp} />
                  </Button>
                </ButtonGroup>
              </view.div>
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
    </view.div>
  );
};
